import mobileLogo from 'common/assets/icons/common/rock-west/rw-logo.svg';
import logo from 'common/assets/icons/common/rock-west/rw-logo-with-text-small.svg';
import { removeAuthCookie } from 'common/bridges/cookies.bridge';
import routes from 'common/constants/routing.constants';
import {
  resetAnalytics,
  trackPageEvent,
} from 'common/utils/client-analytics.util';
import { useWindowSize } from 'common/utils/style.util.js';
import { inject, observer } from 'mobx-react';
import React, { useEffect, useMemo, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import closeSvg from 'common/assets/icons/common/signs/black-thin-close-sign.svg';
import menuSvg from 'common/assets/icons/common/signs/hamburger-menu.svg';
import history from 'customHistory';
import { getPageTitle } from '../../../utils';
import { SwitchAccountType } from '../SwitchAccountType';
import SiteNavbar from '../SiteNavbar';
import {
  Hamburger,
  HeaderSwitchAccountTypeWrapper,
  HeaderTitle,
  Logo,
  LogoImg,
  LogoutContainer,
  MenuBody,
  MenuContainer,
  MenuHeader,
  MenuSide,
  Overlay,
  LanguageSwitcherWrapper,
} from './styled.js';
import { LanguageSwitcher } from '../../../../LanguageSwitcher';

const Menu = (props) => {
  const { ProfileStore, sidebarRef, AppStore } = props;
  const [isOpen, setIsOpen] = useState(false);
  const { width } = useWindowSize();
  const isMobile = width < 564;
  const title = getPageTitle();
  const toggleMenu = () => {
    trackPageEvent('go_to_menu');
    setIsOpen((isOpen) => !isOpen);
  };

  useEffect(() => {
    ProfileStore.getProfileData();
  }, []);

  const isTradingPage = useMemo(
    () => history.location.pathname === routes.trading.path,
    [history],
  );

  return (
    <MenuContainer ref={sidebarRef}>
      {isOpen && <Overlay />}
      <MenuHeader>
        <MenuSide>
          <Logo>
            <LogoImg
              isMobile={isMobile}
              src={isMobile ? mobileLogo : logo}
              onClick={() => props.history.push(routes.trading.path)}
            />
          </Logo>
        </MenuSide>
        <HeaderSwitchAccountTypeWrapper show={isTradingPage}>
          <SwitchAccountType />
        </HeaderSwitchAccountTypeWrapper>
        <HeaderTitle>{title}</HeaderTitle>
        <MenuSide>
          <LanguageSwitcherWrapper>
            <LanguageSwitcher placement="bottom-end" />
          </LanguageSwitcherWrapper>
          <Hamburger onClick={toggleMenu}>
            <img
              width={32}
              height={32}
              src={isOpen ? closeSvg : menuSvg}
              alt="menu"
            />
          </Hamburger>
        </MenuSide>
      </MenuHeader>
      <MenuBody isOpen={isOpen}>
        <SiteNavbar />

        <LogoutContainer onClick={AppStore.logout} data-testid="trading-logout">
          {props.t('common.menu.logout')}
        </LogoutContainer>
      </MenuBody>
    </MenuContainer>
  );
};

export default withRouter(
  withTranslation()(inject('ProfileStore', 'AppStore')(observer(Menu))),
);
